import request from '@/utils/request'
/*
  请求不拿返回值 去掉.then后续代码
*/
/** 首页板块 *********************************************************************/
// 首页接口
export function fetchAccountHome () {
  return request.get(`${process.env.ACOUNT_API}/user/account/home`)
}

/** 行程变更板块 *********************************************************************/
// 未读行程变更弹窗
export function fetchUserModicicationAlert () {
  return request.get(`${process.env.ACOUNT_API}/user/modification/alert`)
}
// H5页面数据
export function fetchModificationOpenUrlByJwy (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/modification/open-url/jwt`, { params: params })
}
// 行程变更列表
export function fetchUserOrderModificationList (params = {}) {
  return request.post(`${process.env.ORDER_MODULE}/user/order/modification/list`, params)
}
// 设置行程变更列表已读
export function editUserOrderModificationSetRead (params = {}) {
  return request.put(`${process.env.ORDER_MODULE}/user/order/modification/set-read`, params)
}

/** 用户信息板块 *********************************************************************/
// 用户信息
export function fetchAccountInfo () {
  return request.get(`${process.env.ACOUNT_API}/user/account/detail`)
}
// 用户省市县地区数据
export function fetchDivisionChinaInfo () {
  return request.get(`${process.env.ACOUNT_API}/administration/division/china?scene=area`)
}
// 用户信息修改
export function editAccount (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/update`, params)
}
// 用户密码修改
export function editAccountAlterPassword (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/alter-password`, params)
}
// 设置新密码
export function createPassword (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/setup-password`, params)
}
// 添加会员
export function createUserMember (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/member`, params)
}
// 加入会员
export function createUserMemberJoin (params = {}) {
  return request.post(`${process.env.ACOUNT_API}//user/member/join`, params)
}
// 邮箱修改发送邮件码
export function createAlterEmailSend (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/alter-email/send`, params)
}
// 手机修改发送短信
export function editAlterMobileSend (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/alter-mobile`, params)
}

/** 用户接口 *********************************************************************/
// 通过密码登陆
export function fetchLoginPasswordInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/login-password`, { params: params })
}
// 通过动态码登陆
export function fetchLoginCaptchaInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/login-captcha`, { params: params })
}
// 发送短信验证码
export function createSmsCode (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/send-sms`, params)
}
// 邮箱重置密码
export function editForgetPasswordEmailReset (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/forget-password/email-reset`, params)
}
// 邮件发送重置密码
export function createForgetPasswordEmailSend (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/forget-password/email-send`, params)
}
// 通过短信重置密码
export function createForgetPasswordMobileReset (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/forget-password/mobile-reset`, params)
}
// 登陆注册二合一
export function createCombineMobile (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/combine-mobile`, params)
}
// 获取邮箱注册码
export function createRegisterEmailCodeSms (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/register-email/send`, params)
}
// 老带新注册
export function createRegisterOfficial (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/register-official`, params)
}
// 来带新登陆
export function fetchLoginOfficialInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/login-official`, { params: params })
}

// 邮箱注册
export function createRegisterEmail (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/register-email`, params)
}
// 邮箱激活
export function editAlterEmailActivation (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/alter-email/activation`, params)
}
// 手机号注册
export function createRegisterMobile (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/register-mobile`, params)
}

/** 行程助手 *********************************************************************/
// 行程助手
export function fetchAccountAssistantList () {
  return request.get(`${process.env.ACOUNT_API}/user/account/assistant`)
}

/** 积分场景 *********************************************************************/
// 会员积分
export function fetchMemberScoreInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/member/score`, { params: params })
}
// 积分转换
export function createScoreTransition (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/member/score/transition`, params)
}
// 获取兑换优惠券列表
export function fetchScoreCouponTemplateList () {
  return request.get(`${process.env.ACOUNT_API}/user/member/score/coupon-template`)
}
// 积分兑换
export function createScoreExchange (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/member/score/exchange`, params)
}

/** 准备清单场景 *********************************************************************/
// 准备清单
export function fetchReadyList (params = {}) {
  return request.get(`${process.env.PLANET_API}/product/route/readylist/` + params.readyId)
}

/** 消息场景 *********************************************************************/
// 消息列表
export function fetchMessageList (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/message/relation`, params)
}
// 将消息状态改为已读
export function editMessageRelation (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/message/relation`, params)
}
// 消息详细
export function fetchMessageInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/message/relation/` + params.messageRelationId)
}

/** 发票场景 *********************************************************************/
// 可以开发票的订单列表
export function fetchInvioceOrderList (params = {}) {
  return request.get(`${process.env.ORDER_URL}/user/invioce/order`, params)
}
// 发票提交申请
export function createInvioce (params = {}) {
  return request.post(`${process.env.ORDER_URL}/user/invioce`, params)
}
// 发票申请列表
export function fetchInvioceList () {
  return request.get(`${process.env.ORDER_URL}/user/invioce`)
}

/** 使用优惠券场景 *********************************************************************/
// 领取优惠券操作
export function createCouponByChannelCode (params = {}, headers) {
  return request.post(`${process.env.ACOUNT_API}/user/coupon/url`, params)
}
// 优惠券路线类型目录列表
export function fetchCouponMenuList (params = {}) {
  return request.get(`${process.env.ROUTE_API}/coupon/${params.couponId}/menu`, { params: params })
}
// 优惠券路线类型目录列表
export function fetchCouponSkuPage (params = {}) {
  return request.get(`${process.env.ROUTE_API}/coupon/${params.couponId}/sku-page`, { params: params })
}
// 通过投放id获取优惠券详情
export function getCouponInfoByDistributionId (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/distribution/${params.couponDistributionId}`)
}
// 优惠券列表
export function fetchCouponPage (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/coupon`, { params: params })
}
// 获取优惠券统计数
export function fetchCouponStatistics (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/coupon/statistics-count`)
}
// 添加优惠券通过短链接
export function createCouponByPassphrase (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/coupon/passphrase`, params)
}

/** 出行人板块 *********************************************************************/
// 出行人列表
export function fetchContactList (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/contact`, { params: params })
}
// 出行人详情通过id查询
export function fetchContactInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/contact/` + params.id)
}
// 新增出行人
export function createContact (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/contact`, params)
}
// 修改出行人
export function editContact (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/contact/` + params.id, params)
}
// 删除出行人通过id
export function deleteContact (params = {}) {
  return request.delete(`${process.env.ACOUNT_API}/user/account/contact/` + params.id)
}

/** 用户收货地址 *********************************************************************/
// 地址列表
export function fetchAddressList (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/address`, { params: params })
}
// 地址详情通过id查询
export function fetchAddressInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/account/address/` + params.id)
}
// 新增地址
export function createAddress (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/account/address`, params)
}
// 修改地址
export function editAddress (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/account/address/` + params.id, params)
}
// 删除地址通过id
export function deleteAddress (params = {}) {
  return request.delete(`${process.env.ACOUNT_API}/user/account/address/` + params.id)
}

/** 老带新地址 *********************************************************************/
// 会员邀请首页信息
export function fetchInvitationHomeInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/invitation/home`, { params: params })
}
// 会员邀请 - 生成记录
export function editInvitationShare (params = {}) {
  return request.put(`${process.env.ACOUNT_API}/user/invitation/update-share/` + params.uuid, params)
}
// 老带新兑换优惠券
export function createInvitationCashExchange (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/member/invitation/cash-exchange`, params)
}
// 老带新优惠券列表
export function fetchInvitationCashTemplateList () {
  return request.get(`${process.env.ACOUNT_API}/user/member/invitation/cash-template`)
}
// 新人推荐路线列表
export function fetchNiceRouteList () {
  return request.get(`${process.env.PLANET_API}/product/route/niceRoute`)
}
// 正在获取小伙伴的邀请暗号
export function fetchDecodeJwtInfo (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/decode/jwt`, { params: params })
}
// 老带新绑定
export function createInvitationBind (params = {}) {
  return request.post(`${process.env.ACOUNT_API}/user/member/invitation/bind`, params)
}

/** 权益卡 *********************************************************************/
// 权益卡类型列表
export function fetchBenefitCardTypeList (params = {}) {
  return request.get(`${process.env.ACOUNT_API}/user/benefit/card/type`, { params: params })
}
// 权益卡列表
export function fetchBenefitCardList (params = {}) {
  params.pageScene = 'list'
  return request.get(`${process.env.ACOUNT_API}/user/benefit/card`, { params: params })
}



// WEBPACK FOOTER //
// ./src/api/user/account.js